import { getEnumValues } from "sprint-common-web";

export interface CloudFilePreviewItem {
    url: string;
    type: FileType;
}

export enum FileType {
    Video = 1,
    Audio = 2,
    Subtitle = 3
}

export const mapToCloudFilePreviewItem = (response: any): CloudFilePreviewItem => {
    validateFileType(response.previewType);

    return {
        url: response.url,
        type: response.previewType
    };
};

export const setCloudFrontAuthCookie = (cloudFrontDomain: string | undefined, accessToken: string): void => {
    if (!cloudFrontDomain) return;
    document.cookie = `token=${encodeURIComponent(accessToken)}; Domain=${cloudFrontDomain}; Path=/; Secure; SameSite=None`;
};

const validateFileType = (value: number) => {
    const validValues = getEnumValues(FileType);

    if (!validValues.includes(value)) {
        throw new Error(`Value '${value}' is not valid FileType.`);
    }
};
